export default {
    surveyCategory: [
        {
            id: 1,
            name: 'Valorant',
            minName: 'VALO',
            image: 'valorant_heros.png',
            active: true,
            visibility: true,
        },
        {
            id: 2,
            name: 'Minecraft',
            minName: 'MC',
            image: 'minecraft_cadi.png',
            active: false,
            visibility: true,
        },
        {
            id: 3,
            name: 'Zula',
            minName: 'Zula',
            image: 'zula_cover.png',
            active: false,
            visibility: false,
        },
        {
            id: 4,
            name: 'Grand Theft Auto V',
            minName: 'GTA5',
            image: 'gta5_cover.jpg',
            active: false,
            visibility: true,
        },
        {
            id: 5,
            name: 'Ateş ve Su',
            minName: 'AteşVeSu',
            image: 'fireboy_watergirl.png',
            active: false,
            visibility: false,
        },
        {
            id: 6,
            name: 'Euro Truck Simulator 2',
            minName: 'ETS',
            image: 'euro_truck_simulator_cover.png',
            active: false,
            visibility: false,
        },
    ],
    surveyQuestions: [
        {
            id: 1,
            surveyId: 1,
            text: "Dereceli maçlara girmeden önce en az 1 kere ölüm maçı, Spike hucüm veya Poligon'a girerim",
        },
        {
            id: 2,
            surveyId: 1,
            text: 'Dereceli maçlarda takımın eksiklilerini gözetlerim. Öyle ki takımda gözcü, kontrol uzmanı gibi eksiklikler varsa bunu dile getiririm veya o karakterleri seçerim',
        },
        {
            id: 3,
            surveyId: 1,
            text: 'Takımıma gelen rastgele oyuncuların Insa-lock atmasını takımım için faydalı bulmam, gerekirse kişiyle kavga ederim',
        },
        {
            id: 4,
            surveyId: 1,
            text: 'Oyun başlar başlamaz karşı takıma gl, hf gibi terimler kullanırım',
        },
        {
            id: 5,
            surveyId: 1,
            text: 'Takım arkadaşım benden silah kaplaması istediğinde bu durumu samimi karşılar, istediğini vermeye çalışırım',
        },
        {
            id: 6,
            surveyId: 1,
            text: "Takımımda 1'den fazla nişancı silahıyla oynayan varsa bunu dile getiririm",
        },
        {
            id: 7,
            surveyId: 1,
            text: "Maç biter bitmez 'gg', 'ez', 'ç@r@z', 'kolaydı', 'kolaysınız' gibi kelimeler kullanırım",
        },
        {
            id: 8,
            surveyId: 1,
            text: 'İlk el ghost silahını satın alırım',
        },
        {
            id: 9,
            surveyId: 1,
            text: 'Bence; takım içi iletişimin iyi kurulması oynayıştan daha önemlidir',
        },
        {
            id: 10,
            surveyId: 1,
            text: 'En fazla öldürme sayısına ulaşmak, iyi oynayış göstergesidir',
        },
        {
            id: 11,
            surveyId: 1,
            text: "Üst üste kazanılan roundlar sonunda karşı takıma 'ff', 'işim var çıkcam hadi seri ff' gibi terimler kullanırım",
        },
        {
            id: 12,
            surveyId: 1,
            text: 'Takım arkadaşım seçtiği karakteri iyi oynayamıyorsa, bir daha bu karakteri seçmemesi gerektiğini söylerim',
        },
        {
            id: 13,
            surveyId: 1,
            text: 'Eğer ultim varsa, ultisi daha gelmemiş takım arkadaşıma bombayı çözüdürüm',
        },
        {
            id: 14,
            surveyId: 1,
            text: 'Boostlananları sevmem ve bu işlemin yapılmasını doğru bulmam',
        },
        {
            id: 15,
            surveyId: 1,
            text: 'Karşı takıma yüksek rütbeli bir oyuncu smurf hesabıyla gelirse, pes edip teslim olma oylamasını başlatırım',
        },
        {
            id: 16,
            surveyId: 2,
            text: 'Karşı takıma yüksek rütbeli bir oyuncu smurf hesabıyla gelirse, pes edip teslim olma oylamasını başlatırım',
        },
    ]
};
